module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "60%"
    }
  }), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("  " + _vm._s(_vm.msg) + " ")]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "60%"
    }
  }), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topic),
      expression: "topic"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Dein Thema?"
    },
    domProps: {
      "value": (_vm.topic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.topic = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.anzahl),
      expression: "anzahl"
    }],
    attrs: {
      "name": "anzahl"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.anzahl = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l(([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.dice()
      }
    }
  }, [_vm._v("Würfeln ...")])]), _c('h2', [_vm._v(_vm._s(_vm.task) + " " + _vm._s(_vm.topic))]), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(item) {
    return _c('li', [_c('img', {
      staticClass: "randimg",
      attrs: {
        "src": '../static/images/' + item + '.svg',
        "alt": _vm.alt[item - 1]
      }
    })])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/secaware-banner.png"),
      "height": "70px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-227bf069!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stories.vue
// module id = 11
// module chunks = 1